import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

// Server functions that wrap the coach-group-seo database queries
// These ensure DB operations only happen on the server

export const getCoachGroupContent = createServerFn({ method: "GET" })
  .validator(
    z.object({
      groupType: z.string(),
      citySlug: z.string().optional(),
      categorySlug: z.string().optional(),
      subcategorySlug: z.string().optional(),
    }),
  )
  .handler(async ({ data }) => {
    const { getCoachGroupContent: dbGetCoachGroupContent } = await import(
      "~/lib/server/coach-group-seo"
    );
    return dbGetCoachGroupContent(data.groupType, {
      citySlug: data.citySlug,
      categorySlug: data.categorySlug,
      subcategorySlug: data.subcategorySlug,
    });
  });

export const getCityPageContent = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCityPageContent: dbGetCityPageContent } = await import(
      "~/lib/server/coach-group-seo"
    );
    return dbGetCityPageContent(data.citySlug);
  });

export const getCategoryPageContent = createServerFn({ method: "GET" })
  .validator(z.object({ categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCategoryPageContent: dbGetCategoryPageContent } = await import(
      "~/lib/server/coach-group-seo"
    );
    return dbGetCategoryPageContent(data.categorySlug);
  });

export const getSubcategoryPageContent = createServerFn({ method: "GET" })
  .validator(z.object({ subcategorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getSubcategoryPageContent: dbGetSubcategoryPageContent } =
      await import("~/lib/server/coach-group-seo");
    return dbGetSubcategoryPageContent(data.subcategorySlug);
  });

export const getCitySubcategoryPageContent = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string(), subcategorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCitySubcategoryPageContent: dbGetCitySubcategoryPageContent } =
      await import("~/lib/server/coach-group-seo");
    return dbGetCitySubcategoryPageContent(data.citySlug, data.subcategorySlug);
  });

export const getCityCategoryPageContent = createServerFn({ method: "GET" })
  .validator(z.object({ citySlug: z.string(), categorySlug: z.string() }))
  .handler(async ({ data }) => {
    const { getCityCategoryPageContent: dbGetCityCategoryPageContent } =
      await import("~/lib/server/coach-group-seo");
    return dbGetCityCategoryPageContent(data.citySlug, data.categorySlug);
  });
